import { Type } from 'class-transformer';
import { IsDate, IsEmail, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { UserId } from '../../../../types';
import { UserDto } from '../../../users/user.dto';
import { PropertyMemberRole, PropertyMemberStatus } from './property-enums';

export class PropertyMemberDto {
  @ValidateNested()
  @IsOptional()
  @Type(() => UserDto)
  user?: UserDto | UserId;

  @IsEmail()
  @IsOptional()
  email?: string;

  @IsString()
  @IsOptional()
  firstName?: string;

  @IsString()
  @IsOptional()
  lastName?: string;

  @IsEnum(PropertyMemberRole)
  role: PropertyMemberRole = PropertyMemberRole.CO_OWNER;

  @IsEnum(PropertyMemberStatus)
  status: PropertyMemberStatus = PropertyMemberStatus.PENDING;

  @ValidateNested()
  @IsOptional()
  @Type(() => UserDto)
  invitedBy?: UserDto | UserId;

  @IsDate()
  @IsOptional()
  invitedAt?: Date;

  @IsDate()
  @IsOptional()
  joinedAt?: Date;
}

export class InvitePropertyMemberDto {
  @IsEmail()
  @IsNotEmpty()
  email!: string;

  @IsEnum(PropertyMemberRole)
  role: PropertyMemberRole = PropertyMemberRole.CO_OWNER;

  @IsOptional()
  @IsString()
  firstName?: string;

  @IsOptional()
  @IsString()
  lastName?: string;
}
